import ConfigNode from 'Model/ConfigNode'
import { branch } from 'Model/constants'

class TypeSizes extends ConfigNode
  @className = 'TypeSizes'

  constructor: ->
    super('typeSizes')

  map: ->
    @get('value')

  update: (map) ->
    @set('value', map, { dataType: 'json' })
    @save()

  reset: ->
    @update({})

  @load: ->
    super('typeSizes', @)

export default TypeSizes
